import { styled } from 'styled-components';

import SkeletonLine from '../SkeletonLine';

// The progress bar itself
export const Progress = styled(SkeletonLine)`
  border-radius: var(--border-radius-tiny);
  height: var(--spacing-small);
`;
